export function transformRemoteOffice(remoteOffice) {
  return {
    id: remoteOffice.id,
    name: remoteOffice.name,
    description: remoteOffice.description,
    port: remoteOffice.port,
    computerIds: remoteOffice.computerIds,
    updatebleOob: remoteOffice.updatebleOob,
    deleteableOob: remoteOffice.deleteableOob,
    proxyConfigId: remoteOffice.proxyConfigId,
    fileServerId: remoteOffice.fileServerId,
  }
}
export function transformRemoteOfficeForServer(remoteOffice) {
  return {
    name: remoteOffice.name,
    description: remoteOffice.description,
    port: remoteOffice.port,
    computerIds: remoteOffice.computerIds,
    updatebleOob: remoteOffice.updatebleOob,
    deleteableOob: remoteOffice.deleteableOob,
    proxyConfigId: remoteOffice.proxyConfigId,
    fileServerId: remoteOffice.fileServerId || 0,
  }
}
